<template>
  <v-tooltip
    :content-class="contentClass ? contentClass : 'setting-tooltip'"
    bottom
    max-width="322px"
    open-delay="350"
    :disabled="!enabled"
  >
    <slot
      v-for="(_,name) in $slots"
      :slot="name"
      :name="name"
    />
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
  </v-tooltip>
</template>

<script>
  export default {
    name: 'SettingTooltip',
    props: {
      enabled: Boolean,
      contentClass: String,
    },
  }
</script>

<style>
.setting-tooltip {
  opacity: 1 !important;
  background: #694361;
}
</style>
